import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Area } from 'src/app/interfaces/area';
import { AreaService } from 'src/app/services/area.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-add-edit-area',
  templateUrl: './add-edit-area.component.html',
  styleUrls: ['./add-edit-area.component.css']
})
export class AddEditAreaComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';

  constructor(private fb: FormBuilder,
    private _areaService: AreaService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute) {
    this.form = this.fb.group({
      name: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getArea(this.id);
    }
  }

  getArea(id: number) {
    this.loading = true;
    this._areaService.getArea(id).subscribe((data: Area) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
      })
    })
  }

  addArea() {
    /*  console.log(this.form.value.name);
     console.log(this.form.get('name')?.value); */

    const area: Area = {
      name: this.form.value.name,
    }
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
      console.log("Editado: "+ area);
      area.id = this.id;
      this._areaService.updateArea(this.id, area).subscribe(() => {
        this.toastr.info(`El area ${area.name} fue actualizado con exito`, 'Areao actualizado');
        this.loading = false;
        this.router.navigate(['/area']);
      })

    } else {
      // Es agregagar
      console.log("Agregado: "+ area);
      this._areaService.saveArea(area).subscribe(() => {
        this.toastr.success(`El area ${area.name} fue registrado con exito`, 'Area registrado');
        this.loading = false;
        this.router.navigate(['/area']);
      })
    }
  }
}
